import React from "react";

import { Action, Category } from "@/constants/events";
import { useEventTracker } from "@/hooks/useEventTracker";
import { useDispatch, useSelector } from "@/redux/hooks";
import { getFormattedLocation } from "@/redux/selectors/location";
import { requestLocation } from "@/redux/slices/location";

type Props = {
  subtitle: string;
  changeLocation: boolean;
  title: string;
  referrer?: string | null;
};
const Subtitle = ({
  subtitle,
  title,
  changeLocation,
  referrer = null,
}: Props) => {
  const dispatch = useDispatch();
  const formattedLocation = useSelector(getFormattedLocation);
  const { publishEvent } = useEventTracker();

  const onClickHandler = () => {
    dispatch(requestLocation());

    publishEvent({
      action: Action.click,
      category: Category.carousel,
      label:
        referrer === "strainDispensaryCarousel"
          ? "strain page dispensary carousel change location"
          : title,
    });
  };

  return (
    <>
      {subtitle}
      {changeLocation && (
        <>
          {" "}
          <button
            onClick={onClickHandler}
            className="font-bold pointer underline"
            data-testid="section-wrapper-location-change"
          >
            {`${formattedLocation}` || "your city"}
          </button>
        </>
      )}
    </>
  );
};

export default Subtitle;
